import Api from '@/api/Api'
import store from '../store'

export default {

  async getList () {
    return store.dispatch('checkResponseApi', await Api().get('permissions'))
  },

}



// WEBPACK FOOTER //
// ./src/api/AppPermission.js